import {
    makeCountMetricFieldFunc,
    makeCurrencyMetricFieldFunc,
    makePercentageMetricFieldFunc,
} from './localUtils'

// Clicks
export const click_throughs__sum = makeCountMetricFieldFunc({
    name: 'Click-Throughs',
    shortName: 'Click-Throughs',
    deltas: ['change', 'percentage_change'],
    id: 'click_throughs__sum',
})
// Purchases
export const purchases_14_day__sum = makeCountMetricFieldFunc({
    name: 'Purchases',
    shortName: 'Purchases',
    deltas: ['change', 'percentage_change'],
    id: 'purchases_14_day__sum',
})

export const total_purchases_14_day__sum = makeCountMetricFieldFunc({
    name: 'Total Purchases',
    shortName: 'Total Purchases',
    deltas: ['change', 'percentage_change'],
    id: 'total_purchases_14_day__sum',
})

export const new_to_brand_purchases_14_day__sum = makeCountMetricFieldFunc({
    name: 'New-To-Brand Purchases',
    shortName: 'New-To-Brand Purchases',
    deltas: ['change', 'percentage_change'],
    id: 'new_to_brand_purchases_14_day__sum',
})

export const total_new_to_brand_purchases_14_day__sum =
    makeCountMetricFieldFunc({
        name: 'Total New-To-Brand Purchases',
        shortName: 'Total New-To-Brand Purchases',
        deltas: ['change', 'percentage_change'],
        id: 'total_new_to_brand_purchases_14_day__sum',
    })

// Units Sold
export const units_sold_14_day__sum = makeCountMetricFieldFunc({
    name: 'Units Sold',
    shortName: 'Units Sold',
    deltas: ['change', 'percentage_change'],
    id: 'units_sold_14_day__sum',
})

export const total_units_sold_14_day__sum = makeCountMetricFieldFunc({
    name: 'Total Units Sold',
    shortName: 'Total Units Sold',
    deltas: ['change', 'percentage_change'],
    id: 'total_units_sold_14_day__sum',
})

export const new_to_brand_units_sold_14_day__sum = makeCountMetricFieldFunc({
    name: 'New-To-Brand Units Sold',
    shortName: 'New-To-Brand Units Sold',
    deltas: ['change', 'percentage_change'],
    id: 'new_to_brand_units_sold_14_day__sum',
})

export const total_new_to_brand_units_sold_14_day__sum =
    makeCountMetricFieldFunc({
        name: 'Total New-To-Brand Units Sold',
        shortName: 'Total New-To-Brand Units Sold',
        deltas: ['change', 'percentage_change'],
        id: 'total_new_to_brand_units_sold_14_day__sum',
    })

// Sales
export const sales_14_day__sum = makeCurrencyMetricFieldFunc({
    name: 'Product Sales',
    shortName: 'Product Sales',
    deltas: ['change', 'percentage_change'],
    id: 'sales_14_day__sum',
})

export const total_sales_14_day__sum = makeCurrencyMetricFieldFunc({
    name: 'Total Product Sales',
    shortName: 'Total Product Sales',
    deltas: ['change', 'percentage_change'],
    id: 'total_sales_14_day__sum',
})

export const new_to_brand_product_sales_14_day__sum =
    makeCurrencyMetricFieldFunc({
        name: 'New-To-Brand Product Sales',
        shortName: 'New-To-Brand Product Sales',
        deltas: ['change', 'percentage_change'],
        id: 'new_to_brand_product_sales_14_day__sum',
    })

export const total_new_to_brand_product_sales_14_day__sum =
    makeCurrencyMetricFieldFunc({
        name: 'Total New-To-Brand Product Sales',
        shortName: 'Total New-To-Brand Product Sales',
        deltas: ['change', 'percentage_change'],
        id: 'total_new_to_brand_product_sales_14_day__sum',
    })

// Cost
export const total_cost__sum = makeCurrencyMetricFieldFunc({
    name: 'Total Cost',
    shortName: 'Total Cost',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'total_cost__sum',
})

export const supply_cost__sum = makeCurrencyMetricFieldFunc({
    name: 'Supply Cost',
    shortName: 'Supply Cost',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'supply_cost__sum',
})

export const amazon_audience_fee__sum = makeCurrencyMetricFieldFunc({
    name: 'Amazon Audience Fee',
    shortName: 'Amazon Audience Fee',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'amazon_audience_fee__sum',
})

export const amazon_platform_fee__sum = makeCurrencyMetricFieldFunc({
    name: 'Amazon Platform Fee',
    shortName: 'Amazon Platform Fee',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'amazon_platform_fee__sum',
})

export const atc_14_day__sum = makeCountMetricFieldFunc({
    name: 'Add To Cart (14 Day)',
    shortName: 'Add to Cart',
    deltas: ['change', 'percentage_change'],
    id: 'atc_14_day__sum',
})

export const atl_14_day__sum = makeCountMetricFieldFunc({
    name: 'Add To List (14 Day)',
    shortName: 'Add to List',
    deltas: ['change', 'percentage_change'],
    id: 'atl_14_day__sum',
})

export const total_detail_page_views_14_day__sum = makeCountMetricFieldFunc({
    name: 'Total Detail Page Views (14 Day)',
    shortName: 'TDPV',
    deltas: ['change', 'percentage_change'],
    id: 'total_detail_page_views_14_day__sum',
})
export const total_subscribe_and_save_subscriptions_14_day__sum =
    makeCountMetricFieldFunc({
        name: 'Total Subscribe and Save Subscriptions (14 Day)',
        shortName: 'Total Sub & Save',
        deltas: ['change', 'percentage_change'],
        id: 'total_subscribe_and_save_subscriptions_14_day__sum',
    })

export const total_add_to_cart_14_day__sum = makeCountMetricFieldFunc({
    name: 'Total Add to Cart (14 Day)',
    shortName: 'Total Add to Cart',
    deltas: ['change', 'percentage_change'],
    id: 'total_add_to_cart_14_day__sum',
})

export const total_add_to_list_14_day__sum = makeCountMetricFieldFunc({
    name: 'Total Add to List (14 Day)',
    shortName: 'Total Add to List',
    deltas: ['change', 'percentage_change'],
    id: 'total_add_to_list_14_day__sum',
})

export const ecpm = makeCurrencyMetricFieldFunc({
    name: 'Effective CPM',
    shortName: 'eCPM',
    deltas: ['change', 'percentage_change'],
    id: 'ecpm',
})

export const dpv_14_day__sum = makeCountMetricFieldFunc({
    name: 'Detail Page Views (14 Day)',
    shortName: 'DPV',
    deltas: ['change', 'percentage_change'],
    id: 'dpv_14_day__sum',
})

export const dpvr_14_day = makePercentageMetricFieldFunc({
    name: 'Detail Page View Rate',
    shortName: 'DPVR',
    isRatio: true,
    deltas: ['change'],
    id: 'dpvr_14_day',
})

export const ecpdpv_14_day = makeCurrencyMetricFieldFunc({
    name: 'Effective Cost per Detail Page View',
    shortName: 'eCPDPV',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'ecpdpv_14_day',
})

export const total_dpvr_14_day = makePercentageMetricFieldFunc({
    name: 'Total Detail Page View Rate',
    shortName: 'TDPVR',
    isRatio: true,
    deltas: ['change'],
    id: 'total_dpvr_14_day',
})

export const total_ecpdpv_14_day = makeCurrencyMetricFieldFunc({
    name: 'Effective Cost per Total Detail Page View',
    shortName: 'eCPTDPV',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'total_ecpdpv_14_day',
})

export const purchase_rate_14_day = makePercentageMetricFieldFunc({
    name: 'Purchase Rate',
    shortName: 'Purchase Rate',
    isRatio: true,
    deltas: ['change'],
    id: 'purchase_rate_14_day',
})

export const total_purchase_rate_14_day = makePercentageMetricFieldFunc({
    name: 'Total Purchase Rate',
    shortName: 'Total Purchase Rate',
    isRatio: true,
    deltas: ['change'],
    id: 'total_purchase_rate_14_day',
})

export const percent_of_purchases_new_to_brand_14_day =
    makePercentageMetricFieldFunc({
        name: 'Percent of Purchases New to Brand',
        shortName: '% Purchases NtB',
        deltas: ['change'],
        id: 'percent_of_purchases_new_to_brand_14_day',
    })

export const roas_14_day = makeCurrencyMetricFieldFunc({
    name: 'Return (14 days) on Ad Spend',
    shortName: 'RoAS',
    deltas: ['change', 'percentage_change'],
    id: 'roas_14_day',
})

export const total_roas_14_day = makeCurrencyMetricFieldFunc({
    name: 'Total Return (14 days) on Ad Spend',
    shortName: 'TRoAS',
    deltas: ['change', 'percentage_change'],
    id: 'total_roas_14_day',
})
export const video_completion_rate = makePercentageMetricFieldFunc({
    name: 'Video Completion Rate',
    shortName: '% Video Complete',
    deltas: ['change'],
    id: 'video_completion_rate',
})

export const ecpvc = makeCurrencyMetricFieldFunc({
    name: 'Effective Cost per Video Completion',
    shortName: 'eCPVC',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'ecpvc',
})

export const new_subscribe_and_save_14_day__sum = makeCountMetricFieldFunc({
    name: 'New Subscribe and Save (14 Day)',
    shortName: 'New Subscribe and Save',
    deltas: ['change', 'percentage_change'],
    id: 'new_subscribe_and_save_14_day__sum',
})
export const video_start__sum = makeCountMetricFieldFunc({
    name: 'Video Start',
    shortName: 'Video Start',
    deltas: ['change', 'percentage_change'],
    id: 'video_start__sum',
})
export const video_midpoint__sum = makeCountMetricFieldFunc({
    name: 'Video Midpoint',
    shortName: 'Video Midpoint',
    deltas: ['change', 'percentage_change'],
    id: 'video_midpoint__sum',
})
export const video_third_quartile__sum = makeCountMetricFieldFunc({
    name: 'Video Third-Quartile',
    shortName: 'Video Third-Quartile',
    deltas: ['change', 'percentage_change'],
    id: 'video_third_quartile__sum',
})
export const video_complete__sum = makeCountMetricFieldFunc({
    name: 'Video Complete',
    shortName: 'Video Complete',
    deltas: ['change', 'percentage_change'],
    id: 'video_complete__sum',
})
export const viewable_impressions__sum = makeCountMetricFieldFunc({
    name: 'Viewable Impressions',
    shortName: 'Viewable Impressions',
    deltas: ['change', 'percentage_change'],
    id: 'viewable_impressions__sum',
})

export const threep_fees_sum = makeCurrencyMetricFieldFunc({
    name: '3P Fees',
    shortName: '3P Fees',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: '3p_fees_sum',
})

export const add_to_cart_clicks__sum = makeCountMetricFieldFunc({
    name: 'Add to Cart Clicks',
    shortName: 'Add to Cart Clicks',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'add_to_cart_clicks__sum',
})

export const add_to_cart_views__sum = makeCountMetricFieldFunc({
    name: 'Add to Cart Views',
    shortName: 'Add to Cart Views',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'add_to_cart_views__sum',
})

export const atc_14_day_rate = makePercentageMetricFieldFunc({
    name: 'Add to Cart Rate (14 Day)',
    shortName: 'Add to Cart Rate',
    isRatio: true,
    deltas: ['change'],
    id: 'atc_14_day_rate',
})

export const atl_14_day_rate = makePercentageMetricFieldFunc({
    name: 'Add to List Rate (14 Day)',
    shortName: 'Add to List Rate',
    isRatio: true,
    deltas: ['change'],
    id: 'atl_14_day_rate',
})

export const agency_fee_sum = makeCurrencyMetricFieldFunc({
    name: 'Agency Fee',
    shortName: 'Agency Fee',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'agency_fee_sum',
})

export const brand_search_rate = makePercentageMetricFieldFunc({
    name: 'Brand Search Rate',
    shortName: 'Brand Search Rate',
    isRatio: true,
    deltas: ['change'],
    id: 'brand_search_rate',
})

export const brand_searches_clicks__sum = makeCountMetricFieldFunc({
    name: 'Branded Searches Clicks',
    shortName: 'Brand Search Clicks',
    deltas: ['change', 'percentage_change'],
    id: 'brand_searches_clicks__sum',
})

export const brand_searches_views__sum = makeCountMetricFieldFunc({
    name: 'Branded Searches Views',
    shortName: 'Brand Search Views',
    deltas: ['change', 'percentage_change'],
    id: 'brand_searches_views__sum',
})

export const combined_ecpp = makeCurrencyMetricFieldFunc({
    name: 'Combined Effective Cost per Purchase',
    shortName: 'Combined eCPP',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'combined_ecpp',
})

export const combined_erpm = makeCurrencyMetricFieldFunc({
    name: 'Combined Effective Revenue per Thousand Impressions',
    shortName: 'Combined eRPM',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'combined_erpm',
})

export const combined_product_sales__sum = makeCurrencyMetricFieldFunc({
    name: 'Combined Product Sales',
    shortName: 'Combined Product Sales',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'combined_product_sales__sum',
})

export const combined_purchases__sum = makeCountMetricFieldFunc({
    name: 'Combined Purchases',
    shortName: 'Combined Purchases',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'combined_purchases__sum',
})

export const combined_purchases_clicks__sum = makeCountMetricFieldFunc({
    name: 'Combined Purchases Clicks',
    shortName: 'Combined Purchases Clicks',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'combined_purchases_clicks__sum',
})

export const combined_purchases_rate = makePercentageMetricFieldFunc({
    name: 'Combined Purchases Rate',
    shortName: 'Combined Purchases Rate',
    isRatio: true,
    deltas: ['change'],
    id: 'combined_purchases_rate',
})

export const combined_purchases_views__sum = makeCountMetricFieldFunc({
    name: 'Combined Purchases Views',
    shortName: 'Combined Purchases Views',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'combined_purchases_views__sum',
})

export const combined_roas = makeCurrencyMetricFieldFunc({
    name: 'Combined Return on Ad Spend',
    shortName: 'Combined RoAS',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'combined_roas',
})

export const combined_units_sold__sum = makeCountMetricFieldFunc({
    name: 'Combined Units Sold',
    shortName: 'Combined Units Sold',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'combined_units_sold__sum',
})

export const detail_page_view_views__sum = makeCountMetricFieldFunc({
    name: 'Detail Page View Views',
    shortName: 'Detail Page View Views',
    deltas: ['change', 'percentage_change'],
    id: 'detail_page_view_views__sum',
})

export const ecpatl_14_day = makeCurrencyMetricFieldFunc({
    name: 'Effective Cost per Add to List (14 Day)',
    shortName: 'eCPATL',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'ecpatl_14_day',
})

export const ecp_brand_search = makeCurrencyMetricFieldFunc({
    name: 'Effective Cost per Brand Search',
    shortName: 'eCPBS',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'ecp_brand_search',
})

export const ecpc = makeCurrencyMetricFieldFunc({
    name: 'Effective Cost per Click',
    shortName: 'eCPC',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'ecpc',
})

export const ecp_new_subscribe_and_save_14_day = makeCurrencyMetricFieldFunc({
    name: 'Effective Cost per New Subscribe and Save (14 Day)',
    shortName: 'eCPSNS',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'ecp_new_subscribe_and_save_14_day',
})

export const new_to_brand_ecp_detail_page_view = makeCurrencyMetricFieldFunc({
    name: 'New-To-Brand Effective Cost per Detail Page View',
    shortName: 'NTB eCPDPV',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'new_to_brand_ecp_detail_page_view',
})

export const ecp_product_review_page_visit = makeCurrencyMetricFieldFunc({
    name: 'Effective Cost per Product Review Page Visit',
    shortName: 'eCPPRPV',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'ecp_product_review_page_visit',
})

export const ecpp = makeCurrencyMetricFieldFunc({
    name: 'Effective Cost per Purchase',
    shortName: 'eCPP',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'ecpp',
})

export const effective_cost_per_purchase_promoted_clicks =
    makeCurrencyMetricFieldFunc({
        name: 'Effective Cost per Purchase (Promoted Clicks)',
        shortName: 'eCPP (Promoted Clicks)',
        isRatio: true,
        deltas: ['change', 'percentage_change'],
        id: 'effective_cost_per_purchase_promoted_clicks',
    })

export const total_ecp_add_to_cart_14_day = makeCurrencyMetricFieldFunc({
    name: 'Effective Cost per Total Add to Cart (14 Day)',
    shortName: 'eCPTAC',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'total_ecp_add_to_cart_14_day',
})

export const total_ecp_add_to_list_14_day = makeCurrencyMetricFieldFunc({
    name: 'Effective Cost per Total Add to List (14 Day)',
    shortName: 'eCPTAL',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'total_ecp_add_to_list_14_day',
})

export const total_ecp_product_review_page_visit = makeCurrencyMetricFieldFunc({
    name: 'Effective Cost per Total Product Review Page Visit',
    shortName: 'eCPTPRPV',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'total_ecp_product_review_page_visit',
})

export const total_ecp_subscribe_and_save_14_day = makeCurrencyMetricFieldFunc({
    name: 'Effective Cost per Total Subscribe and Save (14 Day)',
    shortName: 'eCPTS&S',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'total_ecp_subscribe_and_save_14_day',
})

export const line_item_budget_cap__sum = makeCurrencyMetricFieldFunc({
    name: 'Line Item Budget Cap',
    shortName: 'Line Item Budget Cap',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'line_item_budget_cap__sum',
})

export const new_subscribe_and_save_rate = makePercentageMetricFieldFunc({
    name: 'New Subscribe and Save Rate',
    shortName: 'New Subscribe and Save Rate',
    isRatio: true,
    deltas: ['change'],
    id: 'new_subscribe_and_save_rate',
})

export const new_to_brand_detail_page_view_clicks__sum =
    makeCountMetricFieldFunc({
        name: 'New-To-Brand Detail Page View Clicks',
        shortName: 'NTB DPV Clicks',
        deltas: ['change', 'percentage_change'],
        id: 'new_to_brand_detail_page_view_clicks__sum',
    })

export const new_to_brand_detail_page_view_views__sum =
    makeCountMetricFieldFunc({
        name: 'New-To-Brand Detail Page View Views',
        shortName: 'NTB DPV Views',
        deltas: ['change', 'percentage_change'],
        id: 'new_to_brand_detail_page_view_views__sum',
    })

export const new_to_brand_detail_page_view__sum = makeCountMetricFieldFunc({
    name: 'New-To-Brand Detail Page View',
    shortName: 'NTB DPV',
    deltas: ['change', 'percentage_change'],
    id: 'new_to_brand_detail_page_view__sum',
})

export const new_to_brand_detail_page_view_rate = makePercentageMetricFieldFunc(
    {
        name: 'New-To-Brand Detail Page View Rate',
        shortName: 'NTB DPV Rate',
        isRatio: true,
        deltas: ['change'],
        id: 'new_to_brand_detail_page_view_rate',
    }
)

export const new_to_brand_ecpp = makeCurrencyMetricFieldFunc({
    name: 'New-To-Brand Effective Cost per Purchase',
    shortName: 'NTB eCPP',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'new_to_brand_ecpp',
})

export const new_to_brand_erpm = makeCurrencyMetricFieldFunc({
    name: 'New-To-Brand Effective Revenue per Thousand Impressions',
    shortName: 'NTB eRPM',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'new_to_brand_erpm',
})

export const new_to_brand_purchases_clicks__sum = makeCountMetricFieldFunc({
    name: 'New-To-Brand Purchases Clicks',
    shortName: 'NTB Purchases Clicks',
    deltas: ['change', 'percentage_change'],
    id: 'new_to_brand_purchases_clicks__sum',
})

export const new_to_brand_purchases_views__sum = makeCountMetricFieldFunc({
    name: 'New-To-Brand Purchases Views',
    shortName: 'NTB Purchases Views',
    deltas: ['change', 'percentage_change'],
    id: 'new_to_brand_purchases_views__sum',
})

export const new_to_brand_purchases_rate = makePercentageMetricFieldFunc({
    name: 'New-To-Brand Purchases Rate',
    shortName: 'NTB Purchases Rate',
    isRatio: true,
    deltas: ['change'],
    id: 'new_to_brand_purchases_rate',
})

export const new_to_brand_roas_14_day = makeCurrencyMetricFieldFunc({
    name: 'New-To-Brand Return (14 days) on Ad Spend',
    shortName: 'NTB RoAS',
    deltas: ['change', 'percentage_change'],
    id: 'new_to_brand_roas_14_day',
})

export const off_amazon__sum = makeCountMetricFieldFunc({
    name: 'Off Amazon',
    shortName: 'Off Amazon',
    deltas: ['change', 'percentage_change'],
    id: 'off_amazon__sum',
})

export const off_amazon_cpa = makeCurrencyMetricFieldFunc({
    name: 'Off Amazon CPA',
    shortName: 'Off Amazon CPA',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'off_amazon_cpa',
})

export const off_amazon_clicks__sum = makeCountMetricFieldFunc({
    name: 'Off Amazon Clicks',
    shortName: 'Off Amazon Clicks',
    deltas: ['change', 'percentage_change'],
    id: 'off_amazon_clicks__sum',
})

export const off_amazon_cvr = makePercentageMetricFieldFunc({
    name: 'Off Amazon CVR',
    shortName: 'Off Amazon CVR',
    isRatio: true,
    deltas: ['change'],
    id: 'off_amazon_cvr',
})

export const off_amazon_conversions__sum = makeCountMetricFieldFunc({
    name: 'Off Amazon Conversions',
    shortName: 'Off Amazon Conversions',
    deltas: ['change', 'percentage_change'],
    id: 'off_amazon_conversions__sum',
})

export const off_amazon_erpm = makeCurrencyMetricFieldFunc({
    name: 'Off Amazon Effective Revenue per Thousand Impressions',
    shortName: 'Off Amazon eRPM',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'off_amazon_erpm',
})

export const off_amazon_purchases__sum = makeCountMetricFieldFunc({
    name: 'Off Amazon Purchases',
    shortName: 'Off Amazon Purchases',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'off_amazon_purchases__sum',
})

export const off_amazon_purchases_clicks__sum = makeCountMetricFieldFunc({
    name: 'Off Amazon Purchases Clicks',
    shortName: 'Off Amazon Purchases Clicks',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'off_amazon_purchases_clicks__sum',
})

export const off_amazon_purchases_ecpp = makeCurrencyMetricFieldFunc({
    name: 'Off Amazon Effective Cost per Purchase',
    shortName: 'Off Amazon eCPP',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'off_amazon_purchases_ecpp',
})

export const off_amazon_purchases_rate = makePercentageMetricFieldFunc({
    name: 'Off Amazon Purchases Rate',
    shortName: 'Off Amazon Purchases Rate',
    isRatio: true,
    deltas: ['change'],
    id: 'off_amazon_purchases_rate',
})

export const off_amazon_purchases_views__sum = makeCountMetricFieldFunc({
    name: 'Off Amazon Purchases Views',
    shortName: 'Off Amazon Purchases Views',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'off_amazon_purchases_views__sum',
})

export const off_amazon_roas = makeCurrencyMetricFieldFunc({
    name: 'Off Amazon Return on Ad Spend',
    shortName: 'Off Amazon RoAS',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'off_amazon_roas',
})

export const off_amazon_units_sold__sum = makeCountMetricFieldFunc({
    name: 'Off Amazon Units Sold',
    shortName: 'Off Amazon Units Sold',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'off_amazon_units_sold__sum',
})

export const off_amazon_views__sum = makeCountMetricFieldFunc({
    name: 'Off Amazon Views',
    shortName: 'Off Amazon Views',
    deltas: ['change', 'percentage_change'],
    id: 'off_amazon_views__sum',
})

export const omni_channel_metrics_fee__sum = makeCurrencyMetricFieldFunc({
    name: 'Omni Channel Metrics Fee',
    shortName: 'Omni Channel Metrics Fee',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'omni_channel_metrics_fee__sum',
})

export const product_review_page_visits__sum = makeCountMetricFieldFunc({
    name: 'Product Review Page Visits',
    shortName: 'Product Review Page Visits',
    deltas: ['change', 'percentage_change'],
    id: 'product_review_page_visits__sum',
})

export const product_review_page_visits_clicks__sum = makeCountMetricFieldFunc({
    name: 'Product Review Page Visits Clicks',
    shortName: 'Product Review Page Visits Clicks',
    deltas: ['change', 'percentage_change'],
    id: 'product_review_page_visits_clicks__sum',
})

export const product_review_page_visits_views__sum = makeCountMetricFieldFunc({
    name: 'Product Review Page Visits Views',
    shortName: 'Product Review Page Visits Views',
    deltas: ['change', 'percentage_change'],
    id: 'product_review_page_visits_views__sum',
})

export const product_review_page_visits_rate = makePercentageMetricFieldFunc({
    name: 'Product Review Page Visits Rate',
    shortName: 'Product Review Page Visits Rate',
    isRatio: true,
    deltas: ['change'],
    id: 'product_review_page_visits_rate',
})

export const purchases_clicks__sum = makeCountMetricFieldFunc({
    name: 'Purchases Clicks',
    shortName: 'Purchases Clicks',
    deltas: ['change', 'percentage_change'],
    id: 'purchases_clicks__sum',
})

export const purchases_views__sum = makeCountMetricFieldFunc({
    name: 'Purchases Views',
    shortName: 'Purchases Views',
    deltas: ['change', 'percentage_change'],
    id: 'purchases_views__sum',
})

export const reach__sum = makeCountMetricFieldFunc({
    name: 'Reach',
    shortName: 'Reach',
    deltas: ['change', 'percentage_change'],
    id: 'reach__sum',
})

export const total_add_to_cart_clicks__sum = makeCountMetricFieldFunc({
    name: 'Total Add to Cart Clicks',
    shortName: 'Total Add to Cart Clicks',
    deltas: ['change', 'percentage_change'],
    id: 'total_add_to_cart_clicks__sum',
})

export const total_add_to_cart_views__sum = makeCountMetricFieldFunc({
    name: 'Total Add to Cart Views',
    shortName: 'Total Add to Cart Views',
    deltas: ['change', 'percentage_change'],
    id: 'total_add_to_cart_views__sum',
})

export const total_add_to_cart_rate = makePercentageMetricFieldFunc({
    name: 'Total Add to Cart Rate',
    shortName: 'Total Add to Cart Rate',
    isRatio: true,
    deltas: ['change'],
    id: 'total_add_to_cart_rate',
})

export const total_add_to_list_clicks__sum = makeCountMetricFieldFunc({
    name: 'Total Add to List Clicks',
    shortName: 'Total Add to List Clicks',
    deltas: ['change', 'percentage_change'],
    id: 'total_add_to_list_clicks__sum',
})

export const total_add_to_list_views__sum = makeCountMetricFieldFunc({
    name: 'Total Add to List Views',
    shortName: 'Total Add to List Views',
    deltas: ['change', 'percentage_change'],
    id: 'total_add_to_list_views__sum',
})

export const total_add_to_list_rate = makePercentageMetricFieldFunc({
    name: 'Total Add to List Rate',
    shortName: 'Total Add to List Rate',
    isRatio: true,
    deltas: ['change'],
    id: 'total_add_to_list_rate',
})

export const total_detail_page_view_clicks__sum = makeCountMetricFieldFunc({
    name: 'Total Detail Page View Clicks',
    shortName: 'Total Detail Page View Clicks',
    deltas: ['change', 'percentage_change'],
    id: 'total_detail_page_view_clicks__sum',
})

export const total_detail_page_view_views__sum = makeCountMetricFieldFunc({
    name: 'Total Detail Page View Views',
    shortName: 'Total Detail Page View Views',
    deltas: ['change', 'percentage_change'],
    id: 'total_detail_page_view_views__sum',
})

export const total_ecpp = makeCurrencyMetricFieldFunc({
    name: 'Total Effective Cost per Purchase',
    shortName: 'Total eCPP',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'total_ecpp',
})

export const total_erpm = makeCurrencyMetricFieldFunc({
    name: 'Total Effective Revenue per Thousand Impressions',
    shortName: 'Total eRPM',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'total_erpm',
})

export const total_fee__sum = makeCurrencyMetricFieldFunc({
    name: 'Total Fee',
    shortName: 'Total Fee',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'total_fee__sum',
})

export const total_new_to_brand_ecpp = makeCurrencyMetricFieldFunc({
    name: 'Total New-To-Brand Effective Cost per Purchase',
    shortName: 'Total NTB eCPP',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'total_new_to_brand_ecpp',
})

export const total_new_to_brand_erpm = makeCurrencyMetricFieldFunc({
    name: 'Total New-To-Brand Effective Revenue per Thousand Impressions',
    shortName: 'Total NTB eRPM',
    isRatio: true,
    deltas: ['change', 'percentage_change'],
    id: 'total_new_to_brand_erpm',
})

export const total_new_to_brand_purchases_clicks__sum =
    makeCountMetricFieldFunc({
        name: 'Total New-To-Brand Purchases Clicks',
        shortName: 'Total NTB Purchases Clicks',
        deltas: ['change', 'percentage_change'],
        id: 'total_new_to_brand_purchases_clicks__sum',
    })

export const total_new_to_brand_purchases_percent =
    makePercentageMetricFieldFunc({
        name: 'Total New-To-Brand Purchases Percent',
        shortName: 'Total NTB Purchases %',
        isRatio: true,
        deltas: ['change'],
        id: 'total_new_to_brand_purchases_percent',
    })

export const total_new_to_brand_purchases_views__sum = makeCountMetricFieldFunc(
    {
        name: 'Total New-To-Brand Purchases Views',
        shortName: 'Total NTB Purchases Views',
        deltas: ['change', 'percentage_change'],
        id: 'total_new_to_brand_purchases_views__sum',
    }
)

export const total_new_to_brand_purchases_rate = makePercentageMetricFieldFunc({
    name: 'Total New-To-Brand Purchases Rate',
    shortName: 'Total NTB Purchases Rate',
    isRatio: true,
    deltas: ['change'],
    id: 'total_new_to_brand_purchases_rate',
})

export const total_new_to_brand_roas_14_day = makeCurrencyMetricFieldFunc({
    name: 'Total New-To-Brand Return on Ad Spend',
    shortName: 'Total NTB RoAS',
    isInverse: true,
    deltas: ['change', 'percentage_change'],
    id: 'total_new_to_brand_roas_14_day',
})

export const total_product_review_page_visits__sum = makeCountMetricFieldFunc({
    name: 'Total Product Review Page Visits',
    shortName: 'Total Product Review Page Visits',
    deltas: ['change', 'percentage_change'],
    id: 'total_product_review_page_visits__sum',
})

export const total_product_review_page_visits_clicks__sum =
    makeCountMetricFieldFunc({
        name: 'Total Product Review Page Visits Clicks',
        shortName: 'Total Product Review Page Visits Clicks',
        deltas: ['change', 'percentage_change'],
        id: 'total_product_review_page_visits_clicks__sum',
    })

export const total_product_review_page_visits_views__sum =
    makeCountMetricFieldFunc({
        name: 'Total Product Review Page Visits Views',
        shortName: 'Total Product Review Page Visits Views',
        deltas: ['change', 'percentage_change'],
        id: 'total_product_review_page_visits_views__sum',
    })

export const total_product_review_page_visits_rate =
    makePercentageMetricFieldFunc({
        name: 'Total Product Review Page Visits Rate',
        shortName: 'Total Product Review Page Visits Rate',
        isRatio: true,
        deltas: ['change'],
        id: 'total_product_review_page_visits_rate',
    })

export const total_purchases_clicks__sum = makeCountMetricFieldFunc({
    name: 'Total Purchases Clicks',
    shortName: 'Total Purchases Clicks',
    deltas: ['change', 'percentage_change'],
    id: 'total_purchases_clicks__sum',
})

export const total_purchases_views__sum = makeCountMetricFieldFunc({
    name: 'Total Purchases Views',
    shortName: 'Total Purchases Views',
    deltas: ['change', 'percentage_change'],
    id: 'total_purchases_views__sum',
})

export const total_subscribe_and_save__sum = makeCountMetricFieldFunc({
    name: 'Total Subscribe and Save',
    shortName: 'Total Subscribe and Save',
    deltas: ['change', 'percentage_change'],
    id: 'total_subscribe_and_save__sum',
})

export const total_subscribe_and_save_clicks__sum = makeCountMetricFieldFunc({
    name: 'Total Subscribe and Save Clicks',
    shortName: 'Total Subscribe and Save Clicks',
    deltas: ['change', 'percentage_change'],
    id: 'total_subscribe_and_save_clicks__sum',
})

export const total_subscribe_and_save_rate = makePercentageMetricFieldFunc({
    name: 'Total Subscribe and Save Rate',
    shortName: 'Total Subscribe and Save Rate',
    isRatio: true,
    deltas: ['change'],
    id: 'total_subscribe_and_save_rate',
})

export const video_ad_clicks__sum = makeCountMetricFieldFunc({
    name: 'Video Ad Clicks',
    shortName: 'Video Ad Clicks',
    deltas: ['change', 'percentage_change'],
    id: 'video_ad_clicks__sum',
})
